import { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';
import { EventWidgetDetailV2, WidgetItemEvent } from '../../../../../types/widget';
import { EventItemWithPeriod } from './EventWidgetListTable/EventWidgetListTable';

type UseEventWidgetFormReturnType = {
  widgetItemEvents?: WidgetItemEvent[];
  eventWidgetList: EventItemWithPeriod[];
  handleEventListDragEnd: (list: EventItemWithPeriod[]) => void;
};

export const useEventWidgetForm = (form: WrappedFormUtils): UseEventWidgetFormReturnType => {
  const { widgetItemEvents } = form.getFieldsValue(['widgetItemEvents']) as Pick<
    Partial<EventWidgetDetailV2>,
    'widgetItemEvents'
  >;

  const eventWidgetList =
    widgetItemEvents
      ?.filter((item) => item.event)
      .map((item) => ({ ...item.event, exposurePeriod: item.exposurePeriod, itemId: item.id })) || [];

  const handleEventListDragEnd = (list: EventItemWithPeriod[]): void => {
    if (!widgetItemEvents) return;
    const newList = list.map((item) => widgetItemEvents.find((widgetItem) => widgetItem.id === item.itemId));
    form.setFieldsValue({ widgetItemEvents: newList });
  };

  return { widgetItemEvents, eventWidgetList, handleEventListDragEnd };
};
